<template>
  <v-container :fluid="true" class="home__container">
    <v-row class="landing-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto mt-0">
          <v-col cols="12" lg="6">
            <div class="left-panel-wrapper">
              <h1 class="font-42 text-uppercase">Home insurance</h1>
              <div class="text--underline"></div>
              <ul>
                <li
                  class="font-16 align-start d-flex"
                  v-for="(benefit, index) in listBenefits"
                  :key="index"
                >
                  <v-icon color="#1d8649">mdi-check-circle</v-icon
                  >{{ benefit?.text }}
                </li>
              </ul>
              <v-btn
                :ripple="false"
                depressed
                rounded
                color="mustard"
                x-large
                class="font-weight-bold font-18 text-uppercase width-full"
                @click="openEligibilityDialog()"
              >
                Get a new quote
              </v-btn>
              <div class="text-center">
                <a
                  @click="retrieveQuote"
                  class="text-decoration-underline text-uppercase font-weight-bold"
                  >Retrieve a quote</a
                >
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6" align-self="end">
            <div class="d-flex right-panel-wrapper">
              <a
                class="defaqto"
                title="defaqto compare tool"
                href="https://www.paymentshield.co.uk/advisers/tools-and-support/defaqto-compare-for-clients"
                target="_blank"
              >
                <v-img
                  :width="'135'"
                  :src="require('@/assets/images/defaqto/home-2024.png')"
                  transition="scale-transition"
                  :max-width="'135'"
                  alt="Defaqto 5-star Expert Rated"
                  class="img"
                />
              </a>
              <span
                class="trustpilot-widget"
                data-locale="en-US"
                data-template-id="53aa8807dec7e10d38f59f32"
                data-businessunit-id="58d39bef0000ff00059f0b6a"
                :data-style-height="'77px'"
                :data-style-width="'118px'"
                data-theme="dark"
              >
                <a
                  href="https://www.trustpilot.com/review/paymentshield.co.uk"
                  target="_blank"
                  rel="noopener"
                  >Trustpilot</a
                >
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- What is home insurance? -->
    <v-row class="definition-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="7" lg="6" class="left-panel-wrapper">
            <h2>What is home insurance?</h2>
            <p>
              Your home is probably the most valuable thing you own, and you’ve
              likely spent years saving up for it. It’s not just us who believe
              home insurance is important to have in place.
            </p>
            <p>
              Having the right cover gives you the comfort of knowing your home
              can be repaired or rebuilt should something sudden or unexpected
              happen. With Paymentshield's Home Insurance it’s up to you, you
              can choose to cover your buildings and/or contents and tailor your
              Insurance to meet your needs.
            </p>
          </v-col>
          <v-col cols="5" lg="6">
            <img
              src="@/assets/images/home-insurance.png"
              alt="home-insurance"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- What type of home insurance do I need? -->
    <v-row class="type-insurance-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12">
            <h2>What type of home insurance do I need?</h2>
            <p class="mb-3">
              Your home is probably the most valuable thing you own, and you’ve
              likely spent years saving up for it. Having the right cover gives
              you the comfort of knowing your home can be repaired or rebuilt
              should something sudden or unexpected happen. With our Home
              insurance, you can choose to cover your buildings and/or contents
              and tailor your insurance to meet your specific needs.
            </p>
          </v-col>
          <v-col cols="12" class="d-flex flex-wrap justify-space-between">
            <div
              class="type-insurance__item"
              v-for="(typeInsurance, index) in typeInsurances"
              :key="index"
            >
              <div class="img-wrapper d-flex justify-center align-center">
                <img
                  :src="require(`@/assets/images/${typeInsurance.icon}`)"
                  :alt="typeInsurance?.icon"
                />
              </div>
              <h3>
                {{ typeInsurance?.title }}
              </h3>
              <p v-html="typeInsurance?.description"></p>
            </div>
          </v-col>
          <v-col class="text-center">
            <v-btn
              :ripple="false"
              depressed
              rounded
              color="mustard"
              x-large
              class="font-weight-bold font-18 text-uppercase mx-auto"
              @click="openEligibilityDialog()"
            >
              Get a new quote
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- We love making your life -->
    <v-row class="insurers-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12" md="4">
            <h3 class="font-24">We love making your life</h3>
            <h1 class="font-lobster font-weight-regular">easier</h1>
          </v-col>
          <v-col cols="12" md="8">
            We strongly believe insurance is best purchased alongside
            professional advice and support. That's why you won't find us on
            comparison websites. Instead, we make our insurance available
            through a network of partners who work hard to understand your needs
            and are backed by some of the UK's most recognised insurers.
          </v-col>
          <v-col
            cols="12"
            class="d-flex flex-wrap justify-space-between pt-5 logo-wrapper"
          >
            <div
              class="logo__item"
              v-for="(insurer, index) in insurers"
              :key="index"
            >
              <img
                :src="require(`@/assets/images/${insurer.url}`)"
                alt="insurer.alt"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- What does home insurance cover? -->
    <v-row class="covered-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12">
            <h2>What does home insurance cover?</h2>
            <p class="mb-2">
              The exact level of cover you’ll get will depend on your chosen
              insurance policy. Typically, most home insurance policies will
              offer similar types of protection, while most will also have
              certain exclusions.
            </p>
          </v-col>
          <v-col cols="12" lg="6">
            <h3 class="font-24 d-flex align-center">
              <v-icon color="#1d8649" class="mr-2">mdi-check-circle</v-icon>What
              is usually covered?
            </h3>
            <ul>
              <li
                v-for="(item, index) in listCovered"
                :key="index"
                class="font-18"
              >
                {{ item?.text }}
              </li>
            </ul>
          </v-col>
          <v-col cols="12" lg="6">
            <h3 class="font-24 d-flex align-center flex-wrap">
              <v-icon color="var(--red-500)" class="mr-2"
                >mdi-close-circle</v-icon
              >What&nbsp;
              <span class="text-decoration-underline">isn’t</span>
              &nbsp;usually covered?
            </h3>
            <ul>
              <li
                v-for="(item, index) in listNotCovered"
                :key="index"
                class="font-18"
              >
                {{ item?.text }}
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-row>
          <v-btn @click="showFAQs" class="btn-view-faq"> VIEW FAQs </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <!-- What additional cover is available? -->
    <v-row class="addOn-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12" class="title-wrapper">
            <h2>What additional cover is available?</h2>
            <p>
              You may choose to add optional extras to your policy to give you
              even more protection. Adding home emergency cover or bicycle cover
              to your home insurance can be cheaper than getting them
              separately.
            </p>
          </v-col>
          <v-col
            cols="12"
            class="d-flex justify-space-between add-on__item-wrapper"
          >
            <div
              class="add-on__item"
              v-for="(addOn, index) in addOns"
              :key="index"
            >
              <div class="img-wrapper">
                <img
                  :src="require(`@/assets/images/${addOn.icon}`)"
                  :alt="addOn?.icon"
                />
              </div>
              <h3>
                {{ addOn?.title }}
              </h3>
              <p>
                {{ addOn?.description }}
              </p>
            </div>
          </v-col>
          <v-col class="text-center btn-wrapper">
            <v-btn
              :ripple="false"
              depressed
              rounded
              color="mustard"
              x-large
              class="font-weight-bold font-18 text-uppercase mx-auto"
              @click="openEligibilityDialog()"
            >
              Get a new quote
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Find the right cover for -->
    <v-row class="includes-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12" lg="6" class="left-panel-wrapper">
            <h3 class="text-left">Find the right cover for</h3>
            <h1 class="font-lobster mb-5 text-left font-weight-regular">you</h1>
            <p class="pt-7">
              Whether you need insurance for your buildings or contents, or a
              combination of both, we can help you protect your home, inside and
              out, big or small, with a range of options that let you decide how
              and what you pay for. You can also choose from either our standard
              Home Insurance or our Home Insurance Plus cover, depending on your
              needs.
            </p>
            <p class="pt-1">
              For a summary of the benefits and exclusions please read our
              Product Information Document.
            </p>
          </v-col>
          <v-col cols="12" lg="6" class="right-panel-wrapper">
            <h3>Our Home Insurance includes:</h3>
            <ul>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to £1
                million of cover for your buildings as standard
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to
                £75,000 of cover for your contents with new for old replacement
                as standard
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to
                £200,000 for alternative accommodation provided with our
                buildings cover
              </li>
            </ul>
            <p class="pt-3">
              For an additional cost our ‘Plus’ cover gives you all the benefits
              of our standard cover but with an increased contents cover limit
              up to £100,000.
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Policy documents -->
    <v-row class="document-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12" v-if="isDownloadError" ref="downloadError">
            <v-alert
              dense
              text
              type="error"
              icon="mdi-alert-circle"
              class="ma-0 flex-grow-1 rounded-lg"
            >
              <span class="black--text">
                <strong>Sorry! </strong> Document could not be downloaded at
                this time.
              </span>
            </v-alert>
          </v-col>
          <v-col cols="12">
            <h2>Policy documents</h2>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="document__item document__item--spacing">
              <h3>
                Policy Booklet
                <v-icon color="white" class="mr-2">mdi-file</v-icon>
              </h3>
              <h4>PDF (437KB)</h4>
              <p>
                Download the latest version of our Home Insurance policy
                booklet. This includes full information about what you are and
                aren't covered for.
              </p>
              <div>
                <BaseButton
                  :ripple="false"
                  @click="downloadFile(policyBookletDocument)"
                  depressed
                  rounded
                  color="mustard"
                  x-large
                  className="font-weight-bold font-18 text-uppercase mx-auto"
                  download
                  :loading="policyBookletDocument?.isDownloading"
                  text="DOWNLOAD"
                  loadingText="DOWNLOADING..."
                />
              </div>
            </div>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="document__item">
              <h3>
                Policy Summary
                <v-icon color="white" class="mr-2">mdi-file</v-icon>
              </h3>
              <h4>PDF (141KB)</h4>
              <p>
                Download the latest version of our Home Insurance policy
                summary. This provides an overview of the cover available.
              </p>
              <div>
                <BaseButton
                  :ripple="false"
                  @click="downloadFile(policySummaryDocument)"
                  download
                  depressed
                  rounded
                  color="mustard"
                  x-large
                  className="font-weight-bold font-18 text-uppercase mx-auto"
                  :loading="policySummaryDocument?.isDownloading"
                  text="DOWNLOAD"
                  loadingText="DOWNLOADING..."
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Why choose Paymentshield? -->
    <v-row class="whyChoose-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="12">
            <h2>Why choose Paymentshield?</h2>
          </v-col>
          <v-col
            cols="12"
            class="d-flex flex-xl-wrap justify-space-between reason__item-wrapper"
          >
            <div
              class="reason__item"
              v-for="(reason, index) in whyChoose"
              :key="index"
            >
              <img
                :src="require(`@/assets/images/${reason.icon}`)"
                :alt="reason?.icon"
              />
              <h3 class="text-center">
                {{ reason?.title }}
              </h3>
              <p>
                {{ reason?.description }}
              </p>
            </div>
          </v-col>
          <v-col class="text-center btn-wrapper">
            <v-btn
              :ripple="false"
              depressed
              rounded
              color="mustard"
              x-large
              class="font-weight-bold font-18 text-uppercase mx-auto"
              @click="openEligibilityDialog()"
            >
              Get a new quote
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <EligibilityBaseDialog
      ref="dialogEligibility"
      :windowClass="'confirm-dialog'"
    >
      <template v-slot:content="{ cancel, isShow, title }">
        <Eligibility
          v-if="isShow"
          :handleNextData="{}"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibility"
          :dialogLoading="$refs.dialogLoading"
          :dialogNotMet="$refs.dialogNotMet"
          :isShow="isShow"
          :title="title"
          :listEligibility="HOME_ELIGIBILITY"
          :inforMsg="HOME_ELIGIBILITY_INFO_MSG"
          :customHandleConfirmEligibility="true"
          :continuationUrl="continuationUrl"
          @confirmEligibility="onConfirmEligibility()"
        />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog ref="dialogLoading" :windowClass="'confirm-dialog'">
      <template v-slot:content="{ title }">
        <EligibilityLoading :title="title" />
      </template>
    </EligibilityBaseDialog>

    <EligibilityBaseDialog ref="dialogNotMet" :windowClass="'confirm-dialog'">
      <template v-slot:content="{ cancel, isShow, title }">
        <EligibilityNotMet
          v-if="isShow"
          :cancel="cancel"
          :dialogRef="$refs.dialogEligibility"
          :dialogNotMet="$refs.dialogNotMet"
          :isShow="isShow"
          :title="title"
          :confirmText="'Return to homepage'"
          :isSaveAndExit="false"
          :isSelfserve="true"
        />
      </template>
    </EligibilityBaseDialog>

    <BaseDialog
      ref="retrieveQuote"
      windowClass="pa-0 pb-xl-0 retrieve-quote"
      headerClass="retrieve-quote-header"
      :maxWidth="540"
      headerDivider
      persistent
      noClickAnimation
      @dialogCloseButton="closeRetrieveQuoteForm"
    >
      <template v-slot:content>
        <DialogContentRetrieveQuote
          v-if="showRetrieveQuoteForm"
          @showEligibility="onShowEligibility"
          :quoteReference="quoteReference"
          :pageProductId="pageProductId"
        />
      </template>
    </BaseDialog>

    <RedirectDialog v-if="showRedirectDialog" />

    <v-overlay :value="processingRequest">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { getQuoteAccessIdFromUrl } from "@/common/quotes";
import {
  applyD2CThirdPartyId,
  downloadDocument,
  getLatestStaticDocuments,
} from "@/common/utils";
import BaseButton from "@/components/BaseComponents/BaseButton";
import BaseDialog from "@/components/BaseComponents/BaseDialog";
import EligibilityBaseDialog from "@/components/EligibilityBaseDialog";
import DialogContentRetrieveQuote from "@/components/QuoteResult/DialogContentRetrieveQuote";
import { PRODUCT } from "@/constants/common.constants";
import {
  HOME_ELIGIBILITY,
  HOME_ELIGIBILITY_INFO_MSG,
} from "@/constants/eligibility.constants";
import {
  ADD_ONS,
  HOME_LINK,
  HOME_STATIC_DOCUMENTS,
  INSURERS,
  LIST_BENEFITS,
  LIST_COVERED,
  LIST_NOT_COVERED,
  TYPE_INSURANCES,
  WHY_CHOOSE,
} from "@/constants/home.constants";
import documentService from "@/services/document.service";
import quoteService from "@/services/quote.service";
import sessionService from "@/services/session.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import Eligibility from "@/views/Dialog/Eligibility.vue";
import EligibilityLoading from "@/views/Dialog/EligibilityLoading";
import EligibilityNotMet from "@/views/Dialog/EligibilityNotMet.vue";
import RedirectDialog from "@/views/Dialog/RedirectDialog";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LandingPage",
  components: {
    Eligibility,
    EligibilityBaseDialog,
    EligibilityLoading,
    EligibilityNotMet,
    BaseDialog,
    DialogContentRetrieveQuote,
    RedirectDialog,
    BaseButton,
  },
  data() {
    return {
      HOME_ELIGIBILITY,
      HOME_ELIGIBILITY_INFO_MSG,
      PRODUCT,
      listBenefits: LIST_BENEFITS,
      listCovered: LIST_COVERED,
      listNotCovered: LIST_NOT_COVERED,
      insurers: INSURERS,
      typeInsurances: TYPE_INSURANCES,
      addOns: ADD_ONS,
      whyChoose: WHY_CHOOSE,
      showRetrieveQuoteForm: false,
      showRedirectDialog: false,
      processingRequest: false,
      isDownloadError: false,
      quoteReference: null,
      continuationUrl: null,
      pageProductId: ["1008", "1015"],
      staticDocumentData: [],
      quoteAccessId: null,
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "httpConfig",
      "contactInfo",
      "preparedAnswers",
    ]),
    policyBookletDocument() {
      return this.staticDocumentData?.find((doc) => doc.code === "terms");
    },
    policySummaryDocument() {
      return this.staticDocumentData?.find((doc) => doc.code === "ipid");
    },
  },
  mounted() {
    applyD2CThirdPartyId();
    if (this.$route.query.quoteReference) {
      this.quoteReference = this.$route.query.quoteReference;
      this.retrieveQuote();
    }
    this.getAppConfigurationContactInfo();

    //call API get lastest static document
    this.getStaticDocuments();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "getAppConfigurationContactInfo",
      "confirmEligibility",
      "setHomeEligibility",
    ]),
    async onConfirmEligibility() {
      this.processingRequest = true;
      if (this.quoteAccessId) {
        await this.saveConfirmEligibility();
      } else {
        await this.createQuote(false);
      }
      this.processingRequest = false;
    },
    async openEligibilityDialog() {
      this.processingRequest = true;
      const startResult = await this.startSession();
      this.processingRequest = false;
      if (startResult === true) {
        this.$refs.dialogEligibility.open("Eligibility check");
      }
    },
    /**
     * Start the session with the BFF api
     */
    async startSession(stayInHomePage) {
      try {
        if (this.isQuoteReferenceValid() || this.isLeadIdValid()) {
          await sessionService.startD2CSession(
            this.isLeadIdValid() ? this.$route.query.leadId : null,
            this.$route.query.quoteReference,
            PRODUCT.Home
          );
          return true;
        } else {
          this.openRedirectDialog();
          return false;
        }
      } catch (e) {
        if (
          (!stayInHomePage && e?.response?.status == 404) ||
          e?.response?.status == 403
        ) {
          this.openRedirectDialog();
        }
        return false;
      }
    },
    /**
     * Create d2c quote
     * @param {boolean} stayInHomePage decide to stay in home page if create quote failed
     */
    async createQuote(stayInHomePage) {
      try {
        this.setHomeEligibility("True");
        const response = await quoteService.createOnlineQuote(
          this.preparedAnswers
        );
        window.location.href = response.QuoteRequestContinuationUri;
      } catch (e) {
        if (
          (!stayInHomePage && e?.response?.status == 404) ||
          e?.response?.status == 403
        ) {
          this.openRedirectDialog();
        }
      }
    },
    async saveConfirmEligibility() {
      try {
        const url = await this.confirmEligibility(this.quoteAccessId);
        window.location.href = url;
      } catch (e) {
        console.error(e);
      } finally {
        this.quoteAccessId = null;
      }
    },
    retrieveQuote() {
      this.$refs.retrieveQuote.open("Retrieve a quote");
      this.showRetrieveQuoteForm = true;
    },
    closeRetrieveQuoteForm() {
      this.showRetrieveQuoteForm = false;
    },
    openRedirectDialog() {
      this.showRedirectDialog = true;
    },
    isQuoteReferenceValid() {
      return !!this.$route.query.quoteReference;
    },
    isLeadIdValid() {
      return !(
        this.$route.query.leadId == null ||
        this.$route.query.leadId === "" ||
        isNaN(this.$route.query.leadId) ||
        parseInt(this.$route.query.leadId) <= 0
      );
    },
    async getStaticDocuments() {
      try {
        this.staticDocumentData = await getLatestStaticDocuments(
          PRODUCT.Home,
          HOME_STATIC_DOCUMENTS
        );
      } catch (error) {
        this.isDownloadError = true;
      }
    },
    async downloadFile(file) {
      this.isDownloadError = false;
      file.isDownloading = true;
      try {
        const doc = await documentService.getDocument(
          file.Link,
          this.httpConfig
        );
        downloadDocument(doc, file.fileName);
        file.isDownloading = false;
      } catch (e) {
        this.isDownloadError = true;
        setTimeout(() => {
          const el = this.$refs.downloadError;
          var yourHeight = 80; //heigh of float header panel
          // scroll to your element
          if (el) {
            el.scrollIntoView(true);
          }
          // now account for fixed header
          var scrolledY = window.scrollY;
          if (scrolledY) {
            window.scroll(0, scrolledY - yourHeight);
          }
        }, 500);
        file.isDownloading = false;
        console.error(e);
      }
    },
    showFAQs() {
      window.open(HOME_LINK.FAQS, "_blank");
    },
    onShowEligibility(continuationUrl) {
      this.quoteAccessId = getQuoteAccessIdFromUrl(continuationUrl);
      this.$refs.retrieveQuote.cancel();
      this.closeRetrieveQuoteForm();
      this.$refs.dialogEligibility.open("Eligibility check");
    },
  },
};
</script>
<style lang="scss" scoped>
.v-btn {
  color: $black-2 !important;
  letter-spacing: 0.4px !important;
}

.app-container--width-max {
  max-width: 1074px !important;
  h2 {
    font-size: 32px;
    font-weight: bold;
  }
  h3 {
    font-size: 20px;
    font-weight: bold;
  }
  p {
    font-size: 16px;
  }
  .font-lobster {
    font-size: 64px;
    line-height: 0.7;
  }

  .v-btn {
    height: 60px;
    min-width: 320px;
    margin-top: 16px;
    border-radius: 54px;
  }
}
.home__container {
  color: $black-2;
  margin-top: 12px;
}
.landing-wrapper {
  background-image: url(~@/assets/images/hero.jpeg);
  background-position: 0 75%;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 480px;
  // width: 100%;
  .app-container--width-max {
    max-width: 1096px !important;
  }
  .left-panel-wrapper {
    color: #fff;
    padding: 48px 45px 33px;
    margin-top: 16px;
    margin-left: -10px;
    max-width: 540px;
    width: 540px;
    border-radius: 10px;
    background-color: rgba(39, 39, 39, 0.9);
    h1 {
      font-weight: 800;
    }
    ul {
      list-style-type: none;
      padding-left: 7px;
      margin-top: 11px;
      li {
        padding-top: 17px;
        position: relative;
        .v-icon {
          margin-right: 12px;
        }
        &::before {
          height: 15px;
          width: 15px;
          border-radius: 15px;
          background: #fff;
          content: "";
          left: 4px;
          top: 20px;
          display: inline-block;
          position: absolute;
        }
      }
    }
    .text--underline {
      max-width: 412px;
      height: 2px;
      background: #fff;
      margin-top: -8px;
    }
    .v-btn {
      min-width: 442px;
      margin-top: 36px;
    }
    a {
      color: #fff;
      padding-top: 11px;
      display: inline-block;
    }
    .icon-check {
      margin-right: 12px;
    }
  }
  .right-panel-wrapper {
    padding-left: 173px;
    .defaqto {
      margin-right: 30px;
    }
    .trustpilot-widget {
      background-color: #262625;
      border: 1px solid #000;
      border-radius: 4px;
      padding: 3px 14px 3px 14px;
    }
  }
}

.definition-wrapper {
  padding: 14px 0 14px 0;
  background-color: #fff !important;
  .left-panel-wrapper {
    max-width: 634px;
    min-width: 634px;
    padding-right: 0;
    margin-bottom: 17px;
    h2,
    p {
      max-width: 624px;
    }
    h2 {
      padding-top: 29px;
    }
  }
  .col-5 {
    max-width: 440px;
    padding-right: 0;
    display: flex;
    align-items: center;
    img {
      max-width: 100%;
    }
  }
}

.type-insurance-wrapper {
  background-color: #eff0f0 !important;
  padding: 43px 0 44px 0;
  .type-insurance__item {
    background-color: #fff !important;
    max-width: 320px;
    padding: 28.5px 25px 11px 25px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    .img-wrapper {
      min-height: 86.5px;
      height: 86.5px;
    }
    h3 {
      padding-bottom: 14px;
    }
    p {
      text-align: left;
    }
  }
}

.insurers-wrapper {
  background: $black-2;
  color: #fff;
  padding: 20px 0 18px 0;

  .logo__item {
    display: inline-block;
    img {
      max-height: 35px;
    }
  }
}

.covered-wrapper {
  background: #fff;
  padding: 43px 0 55px 0;
  ul {
    padding-left: 63px;
    li {
      padding-top: 25px;
      &::marker {
        font-size: 20px;
      }
    }
  }
}

.addOn-wrapper {
  background: #eff0f0;
  padding: 59px 0 28px 0;
  .add-on__item {
    background-color: #fff !important;
    max-width: 249px;
    padding: 24px 16px 21px 16px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    .img-wrapper {
      max-height: 100px;
    }
    h3 {
      padding-bottom: 20px;
    }
    p {
      text-align: left;
    }
  }
}

.includes-wrapper {
  background: $black-2;
  color: #fff;
  padding: 29px 0 16px 0;
  .app-container--width-max {
    max-width: 1036px !important;
  }
  h3 {
    font-size: 24px;
  }
  .left-panel-wrapper {
    h1 {
      margin-top: -8px;
    }
    p {
      max-width: 465px;
    }
  }

  p {
    line-height: 1.3;
  }
  ul {
    list-style-type: none;
    padding-left: 20px;
    margin-top: 13px;
    max-width: 420px;

    li {
      padding-left: 20px;
    }
    .mdi-shield {
      margin-left: -20px;
      font-size: 13px;
      margin-right: 0;
    }
  }
}

.document-wrapper {
  background: #fff;
  padding: 33px 0 64px 0;
  .document__item {
    padding: 35px 36px 40px 36px;
    border-radius: 10px;
    background: #354048;
    color: #fff;
    border-radius: 10px;
    max-width: 440px;
    height: auto;
    min-height: 320px;
    margin: 0 10px;
    &--spacing {
      margin-left: auto;
    }
    p {
      padding: 32px 0 34px;
      font-size: 14px;
    }
    h4 {
      font-size: 14px;
      margin-top: -5px;
      font-weight: 600;
    }
    h3 {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      .mdi-file {
        font-size: 35px;
      }
    }
    .v-btn {
      width: 100%;
      height: 54px;
      margin-top: 0;
      font-size: 20px !important;
    }
  }
}

.whyChoose-wrapper {
  background: #eff0f0;
  padding: 44px 0 58px 0;
  h2 {
    margin-bottom: 8px;
  }
  .reason__item {
    max-width: 320px;
    min-height: 414px;
    border-radius: 10px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    background: #fff;
    img {
      max-width: 100%;
    }
    h3 {
      padding: 13px 25px 14px 25px;
    }
    p {
      padding: 0 25px 37px 25px;
      margin-bottom: 0;
    }
  }
  .v-btn {
    margin-top: -8px;
  }
}

@media screen and (max-width: $grid-breakpoints-lg - 1) {
  .home__container {
    margin-top: 0;
    .row {
      margin: 0;
    }
  }
  .app-container--width-max {
    max-width: 100%;
    padding: 0 20px;
    .v-btn {
      min-width: 100% !important;
    }
    h2 {
      font-size: 28px;
    }
  }
  .landing-wrapper {
    min-height: 630px;
    margin: 0;
    background-position: 53% 102%;
    background-size: 281%;
    .left-panel-wrapper {
      width: 100%;
      max-width: 413px;
      margin: 16px auto 0;
      padding: 38px 20px 38px 20px;
      .text--underline {
        display: none;
      }
      h1 {
        font-size: 32px;
        text-decoration: underline;
      }
      ul {
        padding-left: 0;
        margin-top: -12px;
        li {
          padding-top: 30px;

          &::before {
            top: 34px;
            left: 5px;
          }
        }
      }
    }
    .right-panel-wrapper {
      padding-left: 0;
      align-items: center;
      justify-content: center;
      .defaqto {
        margin-right: 24px;
        max-width: 173px;
      }
    }
    .app-container--width-max {
      padding: 0;
    }
  }

  .definition-wrapper {
    margin-top: 0;
    h2 {
      padding-top: 6px !important;
    }
    .col-7,
    .col-5 {
      min-width: 100%;
    }
  }

  .includes-wrapper {
    h3 {
      font-size: 20px;
    }
    .left-panel-wrapper {
      h1 {
      }
    }
  }

  .insurers-wrapper {
    .col-md-4 {
      text-align: center;
    }
    .logo-wrapper {
      .logo__item {
        width: 33%;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: space-around;
        img {
          max-width: 70%;
        }
        &:last-child {
          margin: auto;
        }
      }
    }
  }

  .covered-wrapper {
    padding: 8px 0 15px 0;
    h3 {
      font-size: 20px !important;
    }
    ul {
      li {
        font-size: 16px !important;
        padding-top: 15px;
      }
    }
  }

  .addOn-wrapper {
    padding: 9px 0 28px 0;
    .add-on__item-wrapper {
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .add-on__item {
        min-width: 249px;
        margin-right: 14px;
      }
    }
    .col {
      padding-right: 0;
      &.title-wrapper {
        padding-right: 20px !important;
      }
      .btn-wrapper {
        padding-right: 40px !important;
      }
    }
  }

  .whyChoose-wrapper {
    padding: 8px 0 28px 0;
    .reason__item-wrapper {
      overflow-x: scroll;
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .reason__item {
        margin-bottom: 24px;
        min-width: 320px;
        margin-right: 14px;
      }
    }
    .col {
      padding: 12px 0 12px 12px;
      .btn-wrapper {
        padding-right: 40px !important;
      }
    }
  }

  .type-insurance-wrapper {
    .type-insurance__item {
      margin-bottom: 24px;
      max-width: 100% !important;
      width: 100% !important;
    }
  }

  .document-wrapper {
    padding: 8px 0 28px 0;
    .app-container--width-max {
      padding: 0 12px;
    }
    h2 {
      padding-left: 8px;
    }
    .document__item {
      margin: 0;
      max-width: 100%;
      min-width: 100%;
    }
  }
}

.btn-view-faq {
  width: 320px;
  height: 60px !important;
  border-radius: 54px;
  background-color: #106175 !important;
  font-size: 18px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.4px !important;
  text-align: center;
  color: #fff !important;
  margin: auto;
  margin-top: 37px;
}
</style>
